import { Currency } from '@/core/currency/interfaces';

const LRD: Currency = {
    name: 'Liberian Dollar',
    demonym: 'Liberian',
    majorSingle: 'Dollar',
    majorPlural: 'Dollars',
    codeNumeric: '430',
    symbol: 'L$',
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'LRD',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default LRD;
